import { FormControl, FormLabel } from "@chakra-ui/react";
import { Select } from "chakra-react-select"
import useExternalAuth from "../Tools/useExternalAuth";

export default function Telegram({ setValue }) {
  const { auths } = useExternalAuth({
    auth_provider: "telegram",
  });

  const pageOptions = auths
    ? auths?.map((data) => ({
        value: data.id,
        label: `${data.name}`,
      }))
    : [];

  const handleSelect = ({ value }) => {
    setValue("tool_user_id", value);
  };

  return (
    <>
      <FormControl isRequired>
        <FormLabel>{"Telegram Tool Config"}</FormLabel>
        <Select options={pageOptions} onChange={handleSelect} />
      </FormControl>
    </>
  );
}
